import React, { useState } from "react";
import "../components/modalAddDoctor.css";

import { createPortal } from "react-dom";
import { Constant } from "../../../helper/constant";
import { useNavigate } from "react-router-dom";

const ModalAddDoctor = ({
  isShowModal,
  onCloseModal,
  onSubmitData,
  selectedDoctor,
}) => {
  const navigate = useNavigate();
  const [doctorData, setSelectedDoctorData] = useState(selectedDoctor);
  const [listSuggestionSpeciality, setListSuggestionSpeciality] = useState([]);

  const closeModal = () => {
    setSelectedDoctorData({
      doctor_id: "",
      doctor_name: "",
      doctor_specialist: {
        doctor_specialist_id: "",
        doctor_specialist_name: "",
      },
    });
    onCloseModal();
  };

  const checkSpecialistAutoComplete = (keyword) => {
    if (keyword.length > 3) {
      findSpecialist(keyword);
    } else {
      setListSuggestionSpeciality([]);
    }
  };

  const validateData = () => {
    var isValid = true;
    if (doctorData.doctor_name === "") {
      isValid = false;
      alert("Harap Isi Nama Dokter");
    } else if (doctorData.doctor_specialist.doctor_specialist_id === "") {
      isValid = false;
      alert("Spesialisasi Dokter Tidak Terdaftar");
    }

    if (isValid) {
      const isEditData = doctorData.doctor_id !== "";
      onSubmitData(doctorData, isEditData);
      closeModal();
    }
  };

  // =====================
  // Request Method
  // =====================

  const findSpecialist = async (keyword) => {
    try {
      const response = await fetch(
        Constant.BASE_API_URL + "/spesialis/autocomplete?keyword=" + keyword,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Terdapat Kesalahan Dalam Memproses Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;
      setListSuggestionSpeciality(data.doctor_speciality);
    } catch (error) {
      setListSuggestionSpeciality([]);
    }
  };

  return createPortal(
    isShowModal && (
      <div className="modal-doctor-container">
        <div className="modal-doctor-content">
          <header className="modal-doctor-header">
            <h2 className="modal-doctor-header-title">Tambah Dokter</h2>
            <button
              className="modal-doctor-header-close-button"
              onClick={closeModal}
            >
              &times;
            </button>
          </header>
          <main className="modal-doctor-main">
            <div className="form-doctor-group">
              <div className="input-doctor-title-label-container">
                <span className="input-doctor-title-label ">Nama Dokter</span>
              </div>
              <div className="input-doctor-field">
                <input
                  type="text"
                  value={doctorData.doctor_name ? doctorData.doctor_name : ""}
                  onChange={(e) =>
                    setSelectedDoctorData({
                      ...doctorData,
                      doctor_name: e.target.value,
                    })
                  }
                  placeholder="Masukkan nama dokter"
                />
              </div>
              <div className="input-doctor-title-label-container">
                <span className="input-doctor-title-label ">
                  Spesialisasi Dokter
                </span>
              </div>
              <div className="input-doctor-field">
                <input
                  type="text"
                  value={
                    doctorData.doctor_specialist.doctor_specialist_name || ""
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    setSelectedDoctorData((prevDoctorData) => ({
                      ...prevDoctorData,
                      doctor_specialist: {
                        ...prevDoctorData.doctor_specialist,
                        doctor_specialist_name: value,
                      },
                    }));
                    checkSpecialistAutoComplete(value);
                  }}
                  placeholder="Masukkan nama spesialisasi"
                />
              </div>
              {listSuggestionSpeciality.length > 0 && (
                <ul className="dropdown-list">
                  {listSuggestionSpeciality.map((speciality) => (
                    <li key={speciality.doctor_specialist_id}>
                      <button
                        className="dropdown-button"
                        onClick={() => {
                          setSelectedDoctorData((prevDoctorData) => ({
                            ...prevDoctorData,
                            doctor_specialist: {
                              doctor_specialist_name:
                                speciality.doctor_specialist_name,
                              doctor_specialist_id:
                                speciality.doctor_specialist_id,
                            },
                          }));

                          setListSuggestionSpeciality([]);
                        }}
                      >
                        {speciality.doctor_specialist_name}
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </main>
          <footer className="modal-doctor-footer">
            <button className="modal-close-button" onClick={closeModal}>
              Batal
            </button>
            <button
              className="modal-submit-button"
              onClick={() => {
                validateData();
              }}
            >
              Submit
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalAddDoctor;
